import { render, staticRenderFns } from "./tag-or-untag-customer.vue?vue&type=template&id=8986da6a&"
import script from "./tag-or-untag-customer.vue?vue&type=script&lang=js&"
export * from "./tag-or-untag-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports